import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/types";
import {
  BusinessRole,
  ResourceCategory,
  ResourceType,
  Trade,
} from "@/modules/hub/features/ResourceLibrary/api/getResourceLibratyMetadata/types";
import { getResourceLibraryMetadata } from "@/modules/hub/features/ResourceLibrary/api/getResourceLibratyMetadata/getResourceLibraryMetadataApi";

interface ResourceLibraryMetadataState {
  metadata: {
    trades: Trade[];
    resourceTypes: ResourceType[];
    resourceCategories: ResourceCategory[];
    businessRoles: BusinessRole[];
  } | null;
  loadingGet: boolean;
  errorGet: string | null;
}

const initialState: ResourceLibraryMetadataState = {
  metadata: null,
  loadingGet: false,
  errorGet: null,
};

const resourceLibraryMetadataSlice = createSlice({
  name: "resourceLibraryMetadata",
  initialState,
  reducers: {
    setMetadata: (
      state,
      action: PayloadAction<{
        trades: Trade[];
        businessRoles: BusinessRole[];
        resourceTypes: ResourceType[];
        resourceCategories: ResourceCategory[];
      }>,
    ) => {
      state.metadata = action.payload;
    },
    setLoadingGet: (state, action: PayloadAction<boolean>) => {
      state.loadingGet = action.payload;
    },
    setErrorGet: (state, action: PayloadAction<string | null>) => {
      state.errorGet = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setMetadata, setLoadingGet, setErrorGet, resetFilters } =
  resourceLibraryMetadataSlice.actions;

export const getResourceLibraryMetadataAction =
  (): AppThunk => async (dispatch: AppDispatch) => {
    console.log("[DEBUG-RL] getResourceLibraryMetadataAction CALLED");
    dispatch(setLoadingGet(true));
    dispatch(setErrorGet(null));
    try {
      console.log("[DEBUG-RL] Fetching metadata from REST API...");
      const response = await getResourceLibraryMetadata();
      console.log("[DEBUG-RL] Metadata response:", response);
      dispatch(setMetadata(response.data.filters));
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Failed to fetch metadata.";
      console.log("[DEBUG-RL] Metadata error:", message);
      dispatch(setErrorGet(message));
    } finally {
      dispatch(setLoadingGet(false));
    }
  };

export default resourceLibraryMetadataSlice.reducer;
